import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UnauthorizedState {
  isUnauthorizedModalOpen: boolean
  message: string
}

const initialState: UnauthorizedState = {
  isUnauthorizedModalOpen: false,
  message: 'Your session has expired. Please log in again.',
}

export const unauthorizedSlice = createSlice({
  name: 'unauthorized',
  initialState,
  reducers: {
    setUnauthorizedModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isUnauthorizedModalOpen = action.payload
    },
    setUnauthorizedMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload
    },
    resetUnauthorized: (state) => {
      state.isUnauthorizedModalOpen = false
      state.message = 'Your session has expired. Please log in again.'
    },
  },
})

export const { setUnauthorizedModalOpen, setUnauthorizedMessage, resetUnauthorized } = unauthorizedSlice.actions
export default unauthorizedSlice.reducer
